import React from 'react'
import styled from 'styled-components'

const Offer = styled.div`
    height: 60vh;
    padding: 0 0 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    p {
        position: relative;
        z-index: 2;
        color: #fff;
        font-size: 45px;
        max-width: 600px;
        text-align: center;
        font-weight: 400;
        margin: 12px 0 0;
        line-height: 130%;
    }

    h3 {
        color: #fff;
        position: relative;
        z-index: 2;
        font-size: 18px;
        font-weight: 500;
        margin: 14px 0;
    }

    video {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
`

const DoubleText = styled.div`
    padding: 80px;
    display: flex;
    align-items: center;

    p {
        font-size: 14px;
        color: #1b1b1b;
        margin-bottom: 5px;
        font-weight: 400;
        line-height: 1.5;
    }

    h3 {
        font-size: 18px;
        line-height: 1.8;
    }

    .first {
        margin-right: 15vw;
    }

    .second,
    .first {
        max-width: 490px;
    }
`

const Share = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f9f9f9;
    padding: 140px 0;

    h3 {
        text-align: center;
        max-width: 600px;
        font-size: 24px;
        font-weight: 500;
    }

    p {
        font-weight: 300;
        line-height: 160%;
        text-align: center;
        max-width: 540px;
        color: #363636;
        font-size: 14px;
        margin-top: 20px;
    }
`

const About = () => {
    return (
        <div className="">
            <Offer>
                <h3>Our Story</h3>
                <p>We're on quest for the ultimate Tesla experience.</p>
                <video
                    loop
                    muted
                    playsinline
                    autoPlay
                    src="https://cdn.shopify.com/s/files/1/0319/8225/6172/files/About_us.mp4?v=1628948358"
                ></video>
            </Offer>
            <DoubleText>
                <div className="first">
                    <h3>Our Vision</h3>
                    <p>
                        We created Hills with a simple concept in mind: to give
                        Tesla owners the opportunity to stand out in a world of
                        sameness. An unrivaled blend of technology and
                        innovation, wrapped in stunning design, Tesla redefines
                        personal travel and our ultra-unique accessories are a
                        medium of expression, built to enhance the Tesla
                        experience.
                    </p>
                </div>
                <div className="second">
                    <h3>How we go there</h3>
                    <p>
                        Driven by a passion for functional design and an
                        appreciation for the minimalist Tesla aesthetic, Hills
                        engineers style accessories that integrate seamlessly
                        with select Tesla Models. By handcrafting made-to-order
                        accessories that are manufactured with precision and
                        crafted using noble and natural materials, we go the
                        extra mile in creating a unique Tesla experience.
                    </p>
                </div>
            </DoubleText>
            <Share>
                <h3>
                    We share the same drive regardless of where we are headed,
                    but no matter where the journey takes us, the true quest
                    always lies within.
                </h3>
                <p>
                    At our essence we are human and what makes mankind unique is
                    creative expression. To enable us to tell our very own story
                    and defend a style, Hills is committed to providing
                    high-quality style accessories that accentuate the Tesla
                    experience and extend the drive for innovation and
                    excellence.
                </p>
            </Share>
        </div>
    )
}

export default About
